<template>
  <b-row>
    <b-col>
      <b-row xs="12" v-if="noDeals && !loadingDeals">
        <moow-empty-state
          icon="gavel"
          :title="i18n_local.deals_empty_title"
          :description="i18n_local.deals_empty_desc"
        />
      </b-row>

      <md-table v-if="!noDeals" v-model="filteredDeal" md-card>
        <md-table-toolbar>
          <md-progress-bar md-mode="indeterminate" v-if="loadingDeals"></md-progress-bar>
            <md-field md-clearable class="md-toolbar-section-start">
              <label>Search by tenant, address, status, etc</label>
              <md-input :value="searchInput" @input="filterDeals" @md-clear="resetFilteredDeals"></md-input>
            </md-field>

          <md-field class="md-toolbar-section-end">
            <label for="order">Order by</label>
            <md-select v-model="currentSort" name="order" id="order">
              <md-option value="updatedAt">Last updated</md-option>
              <md-option value="firstName">Tenant first name</md-option>
              <md-option value="lastName">Tenant last name</md-option>
              <md-option value="address">Address</md-option>
              <md-option value="periodStart">Period Start</md-option>
              <md-option value="periodEnd">Period End</md-option>
            </md-select>
          </md-field>

          <!--<div class="deal-summaries md-toolbar-section-end">
            <b-row class="flex-row">
              <b-col><strong>Monthly rent summaries</strong>: {{ monthlySummaries }}</b-col>
              <b-col><strong>Daily rent summaries</strong>: {{ dailySummaries }}</b-col>
            </b-row>
          </div>-->
        </md-table-toolbar>
        <md-table-empty-state md-label="Filtered Deals usually appear here" :md-description="filteringDescription">
          <md-button class="md-primary md-raised" @click="resetFilteredDeals">Clear filter</md-button>
        </md-table-empty-state>
        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          @click="viewDeal(item)"
          :class="{ 'clickable': !item.loading }"
        >
          <md-table-cell v-if="item.loading" md-label="Property" md-sort-by="location">loading...</md-table-cell>
          <md-table-cell
            v-if="!item.loading"
            md-label="Property"
          >{{getDisplayAddress(item.property.address)}}</md-table-cell>

          <md-table-cell
            v-if="!item.loading"
            md-label="Tenant"
            md-sort-by="givenName"
          >{{item.lesseeDet.privatePerson.givenName | capitalize}} {{item.lesseeDet.privatePerson.surname| capitalize}}</md-table-cell>

          <md-table-cell
            v-if="!item.loading"
            md-label="Person/Company"
          >{{getTenantType(item.lesseeDet)}}</md-table-cell>

          <md-table-cell
            v-if="!item.loading && !item.contractDetails.terms.periodEnd"
            md-label="Term"
          >Move in: {{formatTime(item.contractDetails.terms.periodStart)}}</md-table-cell>
          <md-table-cell
            v-else-if="!item.loading"
            md-label="Term"
          >{{formatTime(item.contractDetails.terms.periodStart)}} - {{formatTime(item.contractDetails.terms.periodEnd)}}</md-table-cell>
          <md-table-cell v-if="!item.loading" md-label="Status">
            <md-button
              id="status-cta-button"
              :disabled="isStatusCtaDisabled(item)"
              :class="getStatusCTAClass(item)"
              class="md-primary"
            >{{getBookingStatus(item)}}</md-button>
          </md-table-cell>
        </md-table-row>
      </md-table>
      <div class="md-layout md-alignment-bottom-center mt-3">
        <div v-if="loadingDeals" class="loader-rolling-local_blue"></div>
      </div>
    </b-col>

    <md-dialog :md-active.sync="showStatusCtaDialog">
      <md-dialog-title>
        <div class="md-title">Accept or Decline booking request</div>
      </md-dialog-title>
      <md-dialog-content>
        <p>
          To accept, select contract type.
          <br />Decline cannot be undone!
        </p>
        <md-radio v-model="selectedContractType" value="tenancyAgreement" class="md-primary">
          Tenancy Agreement
          <small>(Simple)</small>
        </md-radio>
        <md-radio
          v-model="selectedContractType"
          value="accomodationTC"
          class="md-primary"
        >Accomodation T&C Contract</md-radio>
        <b-row>
          <md-button class="md-primary md-raised" @click="acceptBooking()">Accept</md-button>
        </b-row>
      </md-dialog-content>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showStatusCtaDialog=false">Cancel</md-button>
        <md-button class="md-accent md-raised" @click="declineBooking()">Decline</md-button>
      </md-dialog-actions>
    </md-dialog>

    <error-snackbar
      :message="errorSnackbarMessage"
      :duration="Number(4000)"
      :showSnackbar="showErrorSnackbar"
      position="center"
      :isInfinity="false"
    ></error-snackbar>
  </b-row>
</template>

<script>
import { ContentLoader } from "vue-content-loader";
import Snackbar from "../../components/snackbar.vue";
import { formatISOShortToDDMonthYYYY } from "../../timeFunctions.js";
import { makeBookingConfirmationDecision } from "../../bookings/bookingsService.js";
import { formatAddress_MuniStreetBuilding_Number } from "@/utils/address/addressUtil.js";
import { mapGetters } from "vuex";
import { debounce } from "lodash/function";
import { BOOKING_STATUS, BOOKING_PAYMENT_STATUS, isBookingPendingForOwnerConfirmation } from "@/bookings/bookingUtil";
export default {
  props: {},
  components: {
    "content-loader": ContentLoader,
    "error-snackbar": Snackbar,
  },
  data() {
    return {
      currentSort: "updatedAt",
      currentSortOrder: "asc",
      blockViewDeal: false,
      searchInput: "",
      selectedBooking: {},
      selectedContractType: "tenancyAgreement",
      showStatusCtaDialog: false,
      showBookingConfirmationDialog: false,
      showBookingRequestDialog: false,
      bookingRequestPeriodStart: undefined,
      bookingRequestPeriodEnd: undefined,
      disabledBookingDates: [],
      loadingDisabledBookingDates: true,
      currentlyInProcessRequestId: -1,
      showErrorSnackbar: false,
      errorSnackbarMessage: "",
      chatClicked: false,
      // dailySummaries: 0,
      // monthlySummaries: 0,
    };
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"]),
    loadingDeals() {
      return this.$store.getters.loadingDeals;
    },
    noDeals() {
      return (
        !this.$store.getters.deals || this.$store.getters.deals.length == 0
      );
    },
    deals() {
      return this.$store.getters.deals;
    },
    filteredDeals() {
      return this.$store.getters.filteredDeals;
    },
    filteredDeal() {
        if (this.filteredDeals.length || this.searchInput) {
            return this.customSort(this.filteredDeals, this.currentSort);
        }

        return this.customSort(this.deals, this.currentSort);
      /*if (!this.searchInput)
        return this.customSort(this.deals, this.currentSort);
      else
        return this.customSort(
          filterDealsBasedOn(this.deals, this.searchInput),
          this.currentSort
        );*/
    },
    showFilteringDescriptor() {
        return this.searchInput && !this.filteredDeals.length;
    },
    filteringDescription() {
        if (this.searchInput.length < 3) {
            return 'At least 3 characters required in order to search';
        }
        if (this.loadingDeals) {
            return `Searching for Deals using keywords "${this.searchInput}"...`;
        }

        return `There are currently no Deals that match keywords "${this.searchInput}"`;
    },
    selectedAccountId() {
      if (this.$store.getters.connectedAccountIds.length > 0)
        return this.$store.getters.connectedAccountIds[0];
      return null;
    },
    canLoadMoreDeals() {
      return this.$store.getters.canLoadMoreDeals;
    },
  },
  watch: {
    selectedAccountId: function(val, oldVal) {
      if (val && val != oldVal) {
        this.getDeals();
        // getDealSummaries(val)
        //   .then(summaries => {
        //     this.dailySummaries = summaries.dailySummaries;
        //     this.monthlySummaries = summaries.monthlySummaries;
        //   })
        //   .catch(error => {
        //     this.notifyError('Summaries are unavailable', 'Cannot obtain information about deal summaries');
        //   });
      }
    },
    searchInput: function (val, oldVal) {
      val
        ? sessionStorage.setItem("lastDealSearchInput", val)
        : sessionStorage.removeItem("lastDealSearchInput");
    },
  },
  created() {
    var memPropSearchInput = sessionStorage.getItem("lastDealSearchInput");
    memPropSearchInput ? (this.searchInput = memPropSearchInput) : void 0;

    if (!this.deals || this.deals.length == 0) {
      if (this.selectedAccountId) this.getDeals();
    }

    if (this.selectedAccountId) {
        this.getDeals();
        // getDealSummaries(this.selectedAccountId)
        //     .then(summaries => {
        //         this.dailySummaries = summaries.dailySummaries;
        //         this.monthlySummaries = summaries.monthlySummaries;
        //     })
        //     .catch(error => {
        //         this.notifyError('Summaries are unavailable', 'Cannot obtain information about deal summaries');
        //     });
    }
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    customSort(items, currentSort) {
      if (!currentSort || !items) return items;
      function compare(a, b) {
        var aSort, bSort, isALargerResult;
        if (currentSort == "updatedAt") {
          aSort = a.updatedAt;
          bSort = b.updatedAt;
          isALargerResult = -1;
        } else if (currentSort == "firstName") {
          aSort = a.lesseeDet.privatePerson.givenName;
          bSort = b.lesseeDet.privatePerson.givenName;
          isALargerResult = 1;
        } else if (currentSort == "lastName") {
          aSort = a.lesseeDet.privatePerson.surname;
          bSort = b.lesseeDet.privatePerson.surname;
          isALargerResult = 1;
        } else if (currentSort == "address") {
          aSort = a.property.address.street;
          bSort = b.property.address.street;
          isALargerResult = 1;
        } else if (currentSort == "periodStart") {
          aSort = a.contractDetails.terms.periodStart;
          bSort = b.contractDetails.terms.periodStart;
          isALargerResult = 1;
        } else if (currentSort == "periodEnd") {
          aSort = a.contractDetails.terms.periodEnd;
          bSort = b.contractDetails.terms.periodEnd;
          isALargerResult = 1;
        }

        let comparison = 0;
        if (aSort > bSort) {
          comparison = isALargerResult;
        } else if (aSort < bSort) {
          comparison = isALargerResult * -1;
        }
        return comparison;
      }
      return items.sort(compare);
    },
    getDeals() {
      this.$store.dispatch("getAccountDeals", {
        accountId: this.selectedAccountId,
      });
    },
    filterDeals: debounce(function (searchString) {
        this.searchInput = searchString;
        if (!searchString) {
            this.resetFilteredDeals();
        }
        if (searchString.length < 3) {
            return;
        }
        this.$store.dispatch("filterDeals", {
            accountId: this.selectedAccountId,
            searchString,
        });
    }, 300),
    resetFilteredDeals() {
        this.searchInput = '';
        this.$store.dispatch('resetFilteredDeals');
    },
    startNewDeal() {
      this.$emit("emitStartNewDeal");
    },
    getLinkToUser(user) {
      return "/#/user/" + user.connectroDet.maaklerID;
    },
    acceptBooking() {
      if (this.selectedContractType) {
        var bookingId = this.selectedBooking._id;
        makeBookingConfirmationDecision({
          bookingId: bookingId,
          decision: "accept",
          bookingType: this.selectedBooking.type,
          contractType: this.selectedContractType,
        });
        // local changes
        this.changeBookingStatus(bookingId, BOOKING_STATUS.accepted);
        this.showStatusCtaDialog = false;
      } else {
        this.showSnackbar("Select contract type to continue!");
      }
    },
    declineBooking() {
      makeBookingConfirmationDecision({
        bookingId: this.selectedBooking._id,
        decision: "decline",
        bookingType: this.selectedBooking.type,
      });
      // local changes
      this.changeBookingStatus(bookingId, BOOKING_STATUS.declined);
      this.showStatusCtaDialog = false;
    },
    isStatusCtaDisabled(deal) {
      if (deal.type != "import" && isBookingPendingForOwnerConfirmation(deal)) return false
      return true;
    },
    getStatusCTAClass(deal) {
      var classes = ["status-cta-btn"];
      if (deal.type === "import") return classes;

      if(deal.status === BOOKING_STATUS.accepted) classes.push("confirmed-button")
      else if(deal.status === BOOKING_STATUS.declined || deal.paymentStatus === BOOKING_PAYMENT_STATUS.payment_cancelled) classes.push("declined-button")
      else if(deal.status === BOOKING_STATUS.cancelled) classes.push("cancelled-button")
      return classes;
    },
    performStatusCta(deal) {
      this.emitCheckCurrUserValidity();
      this.selectedBooking = deal;
      this.showStatusCtaDialog = true;
    },
    getBookingStatus(deal) {
      if (deal.type == "import") return "MANUAL";
      if (isBookingPendingForOwnerConfirmation(deal)) return "ACTION REQUIRED";
      if (deal.status === BOOKING_STATUS.accepted) return "ACCEPTED";
      if (deal.status === BOOKING_STATUS.created) return "CREATED";
      if (deal.status === BOOKING_STATUS.declined) return "DECLINED";
      if (deal.status === BOOKING_STATUS.cancelled) return "CANCELLED";
    },
    getTenantType(lesseeDet) {
      if (lesseeDet.rep == "private") {
        return "Person";
      }
      if (lesseeDet.rep == "juridical") {
        if (lesseeDet.jurPerson && lesseeDet.jurPerson.name)
          return lesseeDet.jurPerson.name;
        else return "Company";
      }
    },
    getDisplayAddress(addressObj) {
      return formatAddress_MuniStreetBuilding_Number(addressObj);
    },
    emitCheckCurrUserValidity() {
      this.$emit("emitCheckCurrUserValidity");
    },
    changeBookingStatus(bookingId, status) {
      this.$store.commit("UPDATE_BOOKING_STATUS", {
        dealId: bookingId,
        status: status,
      });
    },
    reload() {
      this.$store.dispatch("getAccountDeals", {
        accountId: this.selectedAccountId,
        reload: true,
      });
    },
    orderItems(items) {
      if (items) {
        function compare(a, b) {
          const rA = a.updatedAt;
          const rB = b.updatedAt;

          let comparison = 0;
          if (rA < rB) {
            comparison = 1;
          } else if (rA > rB) {
            comparison = -1;
          }
          return comparison;
        }
        return items.sort(compare);
      }
    },
    isPresentInArray(ar, findMe) {
      if (!ar) return false;
      var len = ar.length;
      var i = 0;
      for (; i < len; ) {
        if (ar[i] == findMe) return true;
      }
      return false;
    },
    notifyError(title, msg) {
      this.$notify({
        title: title,
        message: msg,
      });
    },
    formatTime(dateString) {
      return formatISOShortToDDMonthYYYY(dateString);
    },
    viewDeal(deal) {
      if (deal.loading) return;
      this.$emit("emitGoForward", {
        where: "deal",
        params: {
          dealId: deal._id,
          snapshotId: deal.snapshotId,
          ownerViewing: true,
          redirect: "deals",
        },
      });
      // this.$router.push({
      //   name: "deal",
      //   params: {},
      // });
    },
    handleScroll: debounce(function (event) {
      if (!this.canLoadMoreDeals || this.loadingDeals) {
        return;
      }
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        return;
      }
      this.getDeals();
    }, 100),
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/styles/dashboard.css";
@import "../../assets/styles/global.css";
@import "../../assets/styles/variables.scss";

.booking-request-content-container {
  padding: 1em;
}

.status-cta-btn {
  font-weight: bold !important;
  border-radius: 10px;
  border: 0px;
  font-size: 14px;
  font-weight: 400;
  padding: 8px;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
}

.confirmed-button {
  background-color: $fresh-green !important;
  font-weight: 400 !important;
  color: white !important;
}
.declined-button {
  font-weight: 400 !important;
  color: $red-orange !important;
  border-radius: 10px !important;
  border: solid 1px $red-orange !important;
  background-color: white !important;
}

.cancelled-button {
  background-color: $play-yellow !important;
  font-weight: 400 !important;
  color: white !important;
}

.deal-summaries {
  display: flex;
  flex: 1 1 100%;
  justify-content: stretch;

  .flex-row {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/dealPreviews.vue